import api from '../services/api';
import alertService from './alert';

async function fetchQuotationPdfBlob(quotationId, mode) {
  const response = await api.get(`/crm/quotations/${quotationId}/pdf`, {
    responseType: 'blob',
    params: mode ? { mode } : undefined,
  });
  return new Blob([response.data], { type: 'application/pdf' });
}

function extractErrorMessage(err, fallback) {
  if (err.response?.data instanceof Blob) {
    return err.response.data.text().then(text => {
      try {
        return JSON.parse(text)?.message || fallback;
      } catch {
        return fallback;
      }
    });
  }
  return Promise.resolve(err.response?.data?.message || fallback);
}

export async function downloadQuotationPdf(quotation) {
  try {
    const blob = await fetchQuotationPdfBlob(quotation._id);
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${quotation.quotationNumber}.pdf`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  } catch (err) {
    const message = await extractErrorMessage(err, 'Could not download quotation PDF');
    alertService.error('Download Failed', message);
  }
}

export async function previewQuotationPdf(quotation) {
  const tab = window.open('', '_blank');
  try {
    const blob = await fetchQuotationPdfBlob(quotation._id, 'inline');
    const url = URL.createObjectURL(blob);
    if (tab) {
      tab.location.href = url;
    } else {
      alertService.error('Preview Blocked', 'Your browser blocked the preview tab. Please allow pop-ups for this site and try again.');
    }
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  } catch (err) {
    tab?.close();
    const message = await extractErrorMessage(err, 'Could not preview quotation PDF');
    alertService.error('Preview Failed', message);
  }
}
